import { render } from "./button.vue?vue&type=template&id=5b9e584c&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=5b9e584c&scoped=true&lang=css"
import "./button.vue?vue&type=style&index=1&id=5b9e584c&lang=css"
import "./button.vue?vue&type=style&index=2&id=5b9e584c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9e584c"]])

export default __exports__